export default __webpack_public_path__ + "static/SketchGuess-4cf0becc17b63ad874e4f4dcf6f43576.png";